module.exports = __webpack_public_path__ + "img/40.f2b0aa09.jpg";